import { NgModule } from '@angular/core';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { PagesOverviewComponent } from './pages-overview.component';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { StateService, Transition } from '@uirouter/core';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';

const states: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.pages',
        url: '?page&sort_by&sort_dir&&search&page_size&status&type',
        params: {
            page: { dynamic: true },
            sort_by: { dynamic: true },
            sort_dir: { dynamic: true },
            search: { dynamic: true },
            page_size: { dynamic: true },
            status: { dynamic: true },
            type: { dynamic: true },
        },
        views: {
            'content@base.customer.domain': {
                component: PagesOverviewComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Prioritized Pages',
        },
        resolve: [
            {
                token: 'hasAccessToPrioritizedContent',
                deps: [ActiveFeatureService, StateService, MonUIRouterTransitionService, Transition],
                resolveFn: async (
                    ng2ActiveFeatureService: ActiveFeatureService,
                    $state: StateService,
                    ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                    transition: Transition,
                ) => {
                    if (ng2ActiveFeatureService.isFeatureActivePure('prioritized_content_all')) {
                        return Promise.resolve(true);
                    }
                    return ng2MonUIRouterTransitionService.onTransitionFinished(
                        () => {
                            $state.go('base.customer.domain.dashboard', transition.params());
                        },
                    );
                },
            },

        ],
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states })],
    exports: [UIRouterModule],
})
export class PagesOverviewRoutingModule { }
